import { ClassNames } from '@emotion/react';
import { useEffect } from 'react';
import ReactModal from 'react-modal';

import type { Props as ReactModalProps } from 'react-modal';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export const Modal: ReactFCWithChildren<ReactModalProps> = ({
  children,
  isOpen,
  onRequestClose,
  ...props
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [isOpen]);

  useEffect(
    () => () => {
      // this is made to prevent case when modal is removed from react tree
      // but the last isOpen value is true.
      document.body.style.overflow = '';
    },
    [],
  );

  return (
    <ClassNames>
      {({ css, theme }) => (
        <ReactModal
          {...props}
          isOpen={isOpen}
          ariaHideApp={false}
          shouldReturnFocusAfterClose={true}
          onRequestClose={(e) => {
            onRequestClose && onRequestClose(e);
          }}
          contentLabel={'modal'}
          className={css`
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            background: none;
            outline: none !important;
          `}
          overlayClassName={css`
            position: fixed;
            z-index: 10000;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: ${theme.palette.bg.modal};
            display: flex;
            justify-content: center;
          `}
        >
          {children}
        </ReactModal>
      )}
    </ClassNames>
  );
};
